// eslint-disable-next-line default-param-last
export default function contactCardReducer(state = {}, action) {
  switch (action.type) {
    case 'STORE_CONTACT_CARD_DATA':
      return { ...state, [action.data.id]: action.data };

    default:
      return state;
  }
}
